import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Career_Counselling from "./components/career-counselling/Career_Counselling";
import Book_A_Session from "./components/book-a-session/Book_A_Session";
import Test_Page from "./components/test-page/Test_Page";
import Parental_Counselling from "./components/parental-counselling/Parental_Counselling";
import About_Us from "./components/about-us/About_Us";
import Contact_Us from "./components/contact-us/Contact_Us";
import Blogs from "./components/blogs/Blogs";
import Blogs_Inner_Page from "./components/blogs/blogs-inner-page/Blogs_Inner_Page";
import Profile from "./components/profile/Profile";
import Terms_Conditions from "./components/terms-conditions/Terms_Conditions";
import Privacy_Policy from "./components/privacy-policy/Privacy_Policy";
import ScrollToTop from "./components/scrolltotop/ScrollToTop";
import FAQ from "./components/faq/FAQ";
import Test_instructions from "./components/test_instructions/Test_instructions";

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/career-counselling" element={<Career_Counselling />} />
        <Route
          path="/parental-counselling"
          element={<Parental_Counselling />}
        />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<Blogs_Inner_Page />} />
        <Route path="/book-a-session" element={<Book_A_Session />} />
        <Route path="/test-instructions" element={<Test_instructions />} />
        <Route path="/test-page/:id" element={<Test_Page />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/terms-conditions" element={<Terms_Conditions />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
